export const prescriptionType = [
    {
        key: 'All',
        value: '', 
    },
    {
        key: 'Active',
        value: 'active',
    },
    {
        key: 'Discontinued',
        value: 'discontinued',
    },
    {
        key: 'Unverified',
        value: 'unverified',
    }
];